module.exports = __webpack_public_path__ + "img/logo_da.85c29fa7.png";